export const FUNNIES_IMAGE_PATHS = [
  "/comicstrips/1.png",
  "/comicstrips/2.png",
  "/comicstrips/3.png",
  "/comicstrips/4.png",
  "/comicstrips/5.png",
  "/comicstrips/6.png",
  "/comicstrips/7.png",
  "/comicstrips/8.png",
  "/comicstrips/9.png",
  "/comicstrips/10.png",
  "/comicstrips/11.png",
  "/comicstrips/12.png",
  "/comicstrips/13.png",
  "/comicstrips/14.png",
  "/comicstrips/15.png",
  "/comicstrips/16.png",
  "/comicstrips/17.png",
  "/comicstrips/18.png",
];

export const FUNNIES_ROUND_IMAGE_COUNT = 4;
